//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import InventoryIcon from '@mui/icons-material/Inventory';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import EventIcon from '@mui/icons-material/Event';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'proveedor_Id';

export default function SemanasProveedor_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: 'estado',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'Proveedor_Id',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'producto',
            headerName: intl.formatMessage({ id: 'Producto' }),
            editable: false,
            width: 100,
            hide: true
        },
        {
            field: 'proveedor',
            headerName: intl.formatMessage({ id: 'Proveedor' }),
            editable: false,
            width: 300,
            hide: true
        },
        {
            field: 'paletizados',
            headerName: intl.formatMessage({ id: 'Paletas registradas' }),
            editable: false,
            width: 150,
            hide: true
        }, {
            field: 'contenedores',
            headerName: intl.formatMessage({ id: 'Contenedores' }),
            editable: false,
            width: 120,
            hide: true
        },
        {
            field: 'estado',
            headerName: intl.formatMessage({ id: 'Estado' }),
            editable: false,
            width: 120,
            renderCell: (params) => {
                var estado = params.row['estado'];
                var color = estado == "Pendiente" ? "danger" : "success";
                return (
                    <Button color={color} onClick={() => {
                        
                    }}>
                        {params.row['estado']}
                    </Button>
                )
            }
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        semana_Id: false,
        proveedor_Id: false,
    });
    return (
        <div>
            {/*<Toolbar>*/}
            {/*    <div className="row" style={{ width: '100%' }}>*/}
            {/*        <div className="col">*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</Toolbar>*/}
            <Box sx={{
                height: 400, width: 800,
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
